import React, { useMemo, useState, useEffect } from "react"
import he from "he";
import "../Home/MissionSection.css";
import { fixImagePaths } from "../util";
import { useSelector } from "react-redux";

const Commitment = () => {
 
  const [whyWorkWithAkinex, setWhyWorkWithAkinex] = useState("");
  const { page } = useSelector((state) => state.data);

    useEffect(() => {
      if (page?.statusCode === 200 && page?.data?.our_commitment) {
        setWhyWorkWithAkinex(he.decode(page.data.our_commitment.htmlContent));
      }
    }, [page]);

  const processedContent = useMemo(() => fixImagePaths(whyWorkWithAkinex), [whyWorkWithAkinex]);
  
    return (
      <div>
        {processedContent && (
          <div className="whyWorkWithAkinex adminContentParaRemoval" dangerouslySetInnerHTML={{ __html: processedContent }} />
        )}
      </div>
    );
  };
  

export default Commitment;
